import Vue from 'vue'
import Vuex from 'vuex'
import { appModule, consentsModule, driversModule } from './modules'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  modules: {
    app: appModule,
    consents: consentsModule,
    drivers: driversModule
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js